export default __webpack_public_path__ + "static/O0189-2b90e6e6f05851a60fc4152e96c55816.png";